import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Element from 'element-ui'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import thLocale from 'element-ui/lib/locale/lang/th'
import locale from 'element-ui/lib/locale'
import _ from 'lodash'
import store from '../../store'

const kv = [

  {
    id: 'en',
    value: enLocale
  },
  {
    id: 'zh-CN',
    value: zhLocale
  },
  {
    id: 'th',
    value: thLocale
  }

]

Vue.use(VueI18n)
// console.log(store.state.user.userinfo.lang)
const lang = store.state.user.userinfo === null ? 'en' : store.state.user.userinfo.lang

const i18n = new VueI18n({
  locale: lang,
  messages: {
    'en': Object.assign(require('./en/index.json'), enLocale),
    'zh-CN': Object.assign(require('./zh-CN/index.json'), zhLocale),
    'th': Object.assign(require('./th/index.json'), thLocale)
  }
})

locale.use(_.find(kv, {
  'id': lang
}).value)

Vue.use(Element, {
  i18n: key => i18n.vm._t(key)
})

if (module.hot) {
  module.hot.accept(['./en/index.json', './zh-CN/index.json', './th/index.json'], () => {
    i18n.setLocaleMessage('en', Object.assign(require('./en/index.json'), enLocale))
    i18n.setLocaleMessage('zh-CN', Object.assign(require('./zh-CN/index.json'), zhLocale))
    i18n.setLocaleMessage('th', Object.assign(require('./th/index.json'), thLocale))
    console.log('hot reload', this, arguments)
  })
}

export default i18n



// WEBPACK FOOTER //
// ./src/assets/lang/index.js